<div class="modal-header">
  <h4 class="modal-title pull-left">Notifications</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (items.length > 0) {
    <ul class="list-group-notification">
      @for (item of items; track item.name + '-' + $index) {
        <li class="list-group-notification-item">
          @if (item.url) {
            <a [href]="item.url" [title]="item.name" target="_blank" class="clickable text-success mt-3">
              <span [ngClass]="{ 'text-danger': item?.status }">{{ item.name }}</span>
            </a>
          } @else {
            <span
              [ngClass]="{'clickable': true, 'text-danger': item?.status }"
              (click)="onNotificationModalOpen(item)">{{ item.name }}</span>
          }
          - {{ item.title }}
        </li>
      }
    </ul>
  }
</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">
    Close
  </button>
</div>
